import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { AssetAnalysisChartComponent } from './asset-analysis-chart';

@NgModule({
    declarations: [
        AssetAnalysisChartComponent
    ],
    imports: [
        CommonModule,
        NgxChartsModule
    ],
    exports: [
        AssetAnalysisChartComponent
    ]
})
export class AssetAnalysisChartModule { }
